export default "__VITE_ASSET__DfMJXN63__"